

























import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import _get from 'lodash/get'
import _toLower from 'lodash/toLower'

import { Offer, Seller } from '@/types'
import { OfferCartsState } from '@/store/offer-carts/types'
import { OffersState } from '@/store/offers/types'

@Component({
  components: {},
})
export default class UploadInventoryList extends Vue {
  public $refs: any = {
    inventoryListFile: HTMLFormElement,
  }
  private inventoryListFileName: string = 'inventoryList'

  @State('offerCarts') private offerCartsState: OfferCartsState | undefined
  @State('offers') private offersState: OffersState | undefined

  @Getter('getUserInfo', { namespace: 'auth' }) private userInfo: any
  @Getter('getActiveOffer', { namespace: 'offerCarts' }) private activeOffer: Offer | undefined
  @Getter('getOffer', { namespace: 'offers' }) private offer: Offer | undefined
  @Getter('getActiveSeller', { namespace: 'sellers' }) private activeSeller: Seller | undefined

  @Action('getOffer', { namespace: 'offerCarts' }) private getOffer: any
  @Action('uploadInventoryList', { namespace: 'offerCarts' }) private uploadInventoryList: any

  @Mutation('setUploadInventoryListRequired', { namespace: 'offerCarts' })
  private setUploadInventoryListRequired: any

  get uploadingInventoryList() {
    return _get(this.offerCartsState, ['requestUploadInventoryList'])
  }

  private mounted(): void {}

  private onChangeInventoryFile(fieldName, fileList) {
    if (!fileList.length) return
    const file = fileList[0]
    this.$refs.inventoryListFile.value = null

    const offer = this.activeOffer || this.offer
    const userRole = _toLower(_get(this.userInfo, ['role', 'name']))

    if (offer || this.activeSeller || userRole === 'seller') {
      const formData = new FormData()
      formData.append('inventoryList', file, 'inventoryList')
      formData.append('userId', _get(this.userInfo, 'id'))
      formData.append('socketId', this.$socket.client.id)

      if (this.activeSeller) {
        formData.append('sellerId', _get(this.activeSeller, 'id'))
        formData.append('sellerUserId', _get(this.activeSeller, ['sellerUser', 'userId']))
        formData.append('buyerUserId', _get(this.userInfo, 'id'))
      } else if (offer) {
        formData.append('offerId', _get(offer, 'id'))
        formData.append('offerRevisionId', _get(offer, ['offerRevisions', 0, 'id']))
      } else {
        const buyerUserId = _get(this.userInfo, ['sellerUsers', 0, 'seller', 'buyerUserId'])
        if (!buyerUserId) {
          Vue.$toast.error(`You have not been assigned Buyer Rep. Please ask Admin about it.`)
          return
        }

        formData.append('sellerId', _get(this.userInfo, ['sellerUsers', 0, 'seller', 'id']))
        formData.append('sellerUserId', _get(this.userInfo, ['id']))
        formData.append(
          'buyerUserId',
          _get(this.userInfo, ['sellerUsers', 0, 'seller', 'buyerUserId'])
        )
      }

      this.uploadInventoryList(formData)
        .then(res => {
          if (res && res.id) {
            this.getOffer(res.id).then(() => {
              if (this.$route.name !== 'OfferCart') {
                this.$router.replace({ name: 'OfferCart' })
              }
            })
          } else {
            this.$emit('handleFailed')
          }
        })
        .catch(err => {})
    } else if (!this.activeOffer) {
      this.setUploadInventoryListRequired(file)
      this.$router.push({ name: 'Sellers' })
    }
  }
}
